import React from 'react';

import styles from './CategoryList.module.css';

const SubcategoryItem = ({ name, productsCount }) => (
  <li className={styles.subcategory}>
    <div>
      <button
        type="button"
        className={`naked-button reorder-button ${styles.button}`}
      >
        <i className="far fa-ellipsis-v" />
        <i className="far fa-ellipsis-v" />
      </button>
      <span>{name}</span>
    </div>
    <span className={styles.rightContent}>{`${productsCount} ${
      productsCount > 1 ? 'Products' : 'Product'
    }`}</span>
  </li>
);

export default SubcategoryItem;
